export default __webpack_public_path__ + "static/media/photo-verification.71ac8d2b.png";